import { Component, OnInit, ViewChildren, QueryList, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, Validators, FormGroup, NgForm } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { Router, ActivatedRoute } from '@angular/router';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { VoiceService } from '../../_services/voice/voice';
import { ChangeDetectorRef } from '@angular/core';


const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);


// export interface DialogData {
//   setValue: string,
//   setRole: string
// }
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-voice-service-header-reg-list-pe',
  templateUrl: './voice-service-header-reg-list-pe.component.html',
  styleUrls: ['./voice-service-header-reg-list-pe.component.css']
})

export class VoiceServiceHeaderreglistpeComponent implements OnInit {

  maxDate: Date = new Date();
  mindate = new Date(now.getFullYear(), 0, 1);
  maxdate = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  dataSource: MatTableDataSource<any>;

  voiceserviceheaderpeForm: FormGroup;
  public modalRef: BsModalRef;

  form1: any = {};
  data: any = {};
  filterData: any;
  pageNo: number = 1;
  pageSize: number = 5;
  length: number = 5;
  Param: any;
  fetchedData: any;
  noRecord: any;
  afterApply: boolean = false;

  Status: any;
  public queryData: any = { sts: "" };
  searchError: boolean = false;
  showStatusDropdown: boolean = false;
  showHtypDropdown: boolean = false;
  entityName: any;
  entityId: any;
  tmcoolingperiod:any;
  


  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('t1Sort') t1Sort: MatSort;


  dataSubject = new BehaviorSubject<any[]>([]);

  //displayedColumns: string[] = ['URN', 'TMID', 'TMName', 'CLI', 'IndustryType','IndustryTypeOther', 'IndustrySector','IndustrySectorOther', 'Category', 'sts', 'Modification', 'Suspension/Reactivation', 'TMDocs', 'PEDocs', 'HdrCategoryDocs', 'createdAt', 'updatedAt', 'TMComments', 'SuspensionReactivationRemarks', 'PEComments', 'RegComments', 'OtherRegComments', 'LastAction'];

  displayedColumns: string[] = ['URN', 'TMID', 'TMName', 'CLI','HeaderType','OrgType','Industry','IndustryOther', 'IndustrySector','IndustrySectorOther', 'Category', 'sts', 'Suspension/Reactivation', 'TMDocs', 'PEDocs', 'HdrCategoryDocs', 'createdAt', 'updatedAt', 'TMComments', 'PEComments', 'RegComments', 'OtherRegComments', 'LastAction'];

  constructor(
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private vs: VoiceService,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private $: $BroadcastManagerService,
    private modalService: BsModalService,
    private cdr:ChangeDetectorRef,
    private router: Router) {
    this._route.params.subscribe((params) => {
      this.entityName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
      this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
    });
  }


  ngOnInit() {

    this.voiceserviceheaderpeForm = this.fb.group({
      pe_ID: ['',],
      pe_name: ['',]
    });

    this.maxDate.setDate(new Date().getDate());

    this.voiceserviceheaderpeForm.controls['pe_ID'].setValue(this.entityId);
    this.voiceserviceheaderpeForm.controls['pe_name'].setValue(this.entityName);


    this.data = {
      "Start_Date": "",
      "End_Date": "",
      "filterType": "",
      "param": "",
      "EntityID": this.entityId
    }

    this.voiceheaderFilter(this.data)
   this.tmcoolingperiod = Constants.TMCOOLINGPERIOD
    console.log("----------tmcoolingperiod----------",this.tmcoolingperiod)
    this.cdr.detectChanges();
  }

  get f() { return this.voiceserviceheaderpeForm.controls; }


 

  download(urn, file1, folder) {
    var data = {
      Ref_No: urn,
      Folder: folder,
      FileName: file1
    };
    console.log("-------data-----", data)
    this.vs.downloadVoiceServiceFile(data).subscribe((r) => {
      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: "Voice Service Header Registration",
        msg: "File has been downloaded Successfully",
      });
    });
  }


  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  onChangeDataSource(value) {

    this.dataSource = new MatTableDataSource(value.message);
    console.log("------------------values" + this.dataSource);
    this.dataSource.paginator = this.paginator.toArray()[0];
    console.log("values" + value);

    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }




  searchRequired: boolean = false;
  errorSerch() {
    if (this.form1.searchBy && !this.form1.search) {
      this.searchRequired = true;
    } else {
      this.searchRequired = false;

    }
  }
  onSubmitFilter(filterForm, form) {

    console.log(filterForm.value);
    console.log("hi !!!");
    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.search
    console.log("fdate", fdate);
    console.log("ldate", ldate);

    var param = filterForm.search
    if (typeof param === 'undefined' || param == null)
      param = "";

    var filterType
    if (filterForm.searchBy)
      filterType = filterForm.searchBy;

    if (filterForm.searchBy1)
      param = filterForm.searchBy1;
    console.log("-------param-----srch1-----", param)

    if (filterForm.search)
      param = filterForm.search;
    console.log("-------param----srch------", param)



    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)
    console.log("difference_in_Timedifference_in_Time in days", difference_in_Time)



    if (fdate != "" && ldate == "") {
      ldate = cdate
    }

    this.data = {

      "Start_Date": fdate,
      "End_Date": ldate,
      "filterType": filterType,
      "param": param,
      "EntityID": this.entityId
    }

    if (fdate == "" && ldate == "" && param == "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
    }
    else {
      this.voiceheaderFilter(this.data)
    }
  }

  voiceheaderFilter(data) {

    this.vs.voiceServiceHeaderbypeFilter(data)
      .subscribe(r => {
        console.log(r)
        this.fetchedData = JSON.stringify(r);
        console.log("----------fetcch---------------------", this.fetchedData)
        this.dataSource = r;
        console.log("---------datasource----------------", this.dataSource)
        this.onChangeDataSource(r);

      })
  }


  Modifyhdr(urn: string) {
    this.modalRef = this.modalService.show(ModalPromptComponent);
    this.modalRef.content.modalDataObj = {
      title: "Voice Service Header",
      msg: "Do you like to modify the voice header details"
    }
    this.modalRef.content.onClose.subscribe(result => {
      if (result == true) {
        this.router.navigateByUrl('/voice-service-header-modification-pe;urn=' + urn)
      }
    })
  }

  

  // modalwithradio(final: any) {
  //   console.log("-----------input element--------", final)
  //   this.modalRef = this.modalService.show(ModalPromptComponent);
  //   this.modalRef.content.voiceModalDataObj = {
  //     title: "Voice Header",
  //     msg: "Do you like to suspend the Header Temporarily or Permanently",
  //     showRadioButton: true,
  //     radioOptions: ["Temporary", "Permanent"],
  //   };


  //   this.modalRef.content.onClose.subscribe((result) => {
  //     if (result == true) {
  //       const selectedOption = this.modalRef.content.selectedOption;
  //       let status;
  //       if (selectedOption === "Permanent") {
  //         status = "RT";
  //       } else if (selectedOption === "Temporary") {
  //         status = "DT";
  //       }

  //       let datavalue = {
  //         urn: final.urn,
  //         cli: final.cli,
  //         entityID: this.db.get(
  //           Constants.SESSSION_STORAGE,
  //           Constants.ENTITY_ID
  //         ),
  //         status: status,
  //         selectedOption: selectedOption,
  //         eclass: "TM"
  //       };
  //       console.log("----------datavalue----", datavalue);

  //       this.vs.voicesuspensionreactivation(datavalue).subscribe((r) => {
  //         if (r.status == "success") {
  //           this.voiceheaderFilter(this.data)
  //           this.resetvalue();
  //           console.log("---data---", this.data);
  //           this.$modal.successModal({
  //             title: "Voice Header Suspension/ Revocation",
  //             msg: "Voice Header has been suspended successfully",
  //           });
  //         } else {
  //           this.$modal.errorModal({
  //             title: "Voice Header Suspension/ Revocation",
  //             msg: r.msg,
  //           });
  //         }
  //       });

  //     }
  //   });
  // }






  modalwithradio(final: any) {
    console.log("-----------input element--------", final)
    this.modalRef = this.modalService.show(ModalPromptComponent);
    this.modalRef.content.voiceModalDataObj = {
      title: "Voice Service Header",
      msg: "Do you like to suspend the Header Temporarily or Permanently",
      showRadioButton: true,
      radioOptions: ["Temporary", "Permanent"],
      
    };

    this.modalRef.content.onClose.subscribe((result) => {

      if (result == true) {
        const selectedOption = this.modalRef.content.selectedOption;
        let remarks = this.modalRef.content.remarks;
        // let status;
        if (selectedOption === "Permanent") {


          this.modalRef = this.modalService.show(ModalPromptComponent);
          this.modalRef.content.modalDataObj = {
            title: "Voice Service Header Permanant Suspension",
            msg: "PE will be de-linked with TM post suspension and calls cannot be made using this header. Request for re-registration of header can be initiated by PE only after " + Constants.TMCOOLINGPERIOD + " days, would you like to still continue?",
          }
          this.modalRef.content.onClose.subscribe(result => {
            if (result === true) {
              // status = "RP";
              let datavalue = {
                urn: final.urn,
                cli: final.cli,
                entityID: this.db.get(
                  Constants.SESSSION_STORAGE,
                  Constants.ENTITY_ID
                ),
                status: "RP",
                selectedOption: selectedOption,
                remarks: remarks,
                eclass: "PE"
              };
              console.log("----------datavalue----", datavalue);

              this.vs.voiceServiceSuspensionReactivation(datavalue).subscribe((r) => {
                if (r.status == "success") {
                  this.resetvalue()
                  console.log("---data---", this.data);
                  this.$modal.successModal({
                    title: "Voice Service Header Suspension",
                    msg: "Voice Service Header has been suspended successfully",
                  });


                } else {
                  this.$modal.errorModal({
                    title: "Voice Service Header Suspension",
                    msg: r.msg,

                  });
                }
              });
            }
          })

        } else if (selectedOption === "Temporary") {

          this.modalRef = this.modalService.show(ModalPromptComponent);
          this.modalRef.content.modalDataObj = {
            title: "Voice Header Temporary Suspension",
            msg: "Calls cannot be made using this header post suspension, would you like to still continue?",
          }
          this.modalRef.content.onClose.subscribe(result => {
            if (result === true) {           
              let datavalue = {
                urn: final.urn,
                cli: final.cli,
                entityID: this.db.get(
                  Constants.SESSSION_STORAGE,
                  Constants.ENTITY_ID
                ),
                status: "DP",
                selectedOption: selectedOption,
                remarks: remarks,
                eclass: "PE"
              };
              console.log("----------datavalue----", datavalue);

              this.vs.voiceServiceSuspensionReactivation(datavalue).subscribe((r) => {
                if (r.status == "success") {
                  this.resetvalue()
                  console.log("---data---", this.data);
                  this.$modal.successModal({
                    title: "Voice Service Header Suspension",
                    msg: "Voice Service Header has been suspended successfully",
                  });


                } else {
                  this.$modal.errorModal({
                    title: "Voice Service Header Suspension",
                    msg: r.msg,

                  });
                }
              });
            }

          })
        }
      
      }
    });
  }

  permSuspension(final){
    console.log("----reactivate----");
      this.modalRef = this.modalService.show(ModalPromptComponent);
      this.modalRef.content.modalDataObj = {      
        title: "Voice Service Header Permanant Suspension",
        msg: "PE will be de-linked with TM post suspension and calls cannot be made using this header. Request for re-registration of header can be initiated by PE only after " + Constants.TMCOOLINGPERIOD + " days, would you like to still continue?",
      }
      this.modalRef.content.onClose.subscribe(result => {
        if (result === true) {       
          let datavalue = {
            urn: final.urn,
            cli: final.cli,
            entityID: this.db.get(
              Constants.SESSSION_STORAGE,
              Constants.ENTITY_ID
            ),
            status: "RP",      
            eclass: "PE"
          };
          console.log("----------datavalue----", datavalue);
  
          this.vs.voiceServiceSuspensionReactivation(datavalue).subscribe((r) => {
            if (r.status == "success") {
              this.resetvalue()
              console.log("---data---", this.data);
              this.$modal.successModal({
                title: "Voice Service Header Suspension",
                msg: "Voice Service Header has been suspended successfully",
              });
            } else {
              this.$modal.errorModal({
                title: "Voice Service Header Suspension",
                msg: r.msg,
              });
            }
          });
        }
      })
    }

  reactivatefn(final) {
    console.log("----reactivate----");
    this.modalRef = this.modalService.show(ModalPromptComponent);
    this.modalRef.content.modalDataObj = {
      title: "Voice Service Header Reactivation",
      msg: "Are you sure you want to Reactivate the header",
      showremarks: true
    }
    this.modalRef.content.onClose.subscribe(result => {
      if (result === true) {
        let datavalue = {
          urn: final.urn,
          cli: final.cli,
          entityID: this.db.get(
            Constants.SESSSION_STORAGE,
            Constants.ENTITY_ID
          ),
          status: "A",
          remarks: this.modalRef.content.remarks,
          eclass: "PE"
        };
        console.log("----------datavalue----", datavalue);
        this.vs.voiceServiceSuspensionReactivation(datavalue).subscribe((r) => {
          if (r.status == "success") {
            //this.voiceheaderFilter(this.data)
            this.resetvalue();
            console.log("---data---", this.data);
            this.$modal.successModal({
              title: "Voice Service Header Reactivation",
              msg: "Voice Service Header has been Reactivated successfully",

            });
          } else {

            this.$modal.errorModal({
              title: "Voice Service Header Reactivation",
              msg: r.msg,
            });
          }
        });
      }
    })
  }

  // reset() {
  //   let data = {
  //     Start_Date: "",
  //     End_Date: "",
  //     filterType: "",
  //     param: "",
  //     EntityID: this.entityId,
  //   };
  //   this.form1.searchBy1 = null
  //   this.voiceheaderFilter(data);
  // }

  resetvalue() {
    let data = {
      Start_Date: "",
      End_Date: "",
      filterType: "",
      param: "",
      EntityID: this.entityId,
    };
    this.form1.searchBy1 = null
    this.voiceheaderFilter(data);
  }


  openDropdown(value) {
    this.showStatusDropdown = false
    this.showHtypDropdown = false
    if (value == "Status") {
      this.showStatusDropdown = true;
    } else if(value == "HeaderType") {
      this.showHtypDropdown = true;
    }
  }

  downloadServiceHeaderpeListCSV() {
    
    // var data = {

    // }
    // if (this.entityId)
    //   data["EntityID"] = this.entityId


    var fileName;
    const currentdate = formatDate(now, 'medium', 'en-US', '+0530');
    this.vs.exportServiceHeaderpeListCSV(this.data).subscribe(r => {
      fileName = currentdate + this.entityId + '_IP.csv';


      importedSaveAs(r, fileName)
      this.$modal.successModal({
        title: 'PE List',
        msg: 'File has been downloaded Successfully'
      });
    })

  }

}




